import { TestHelper } from '@4finance/cwt-test-helper';
import '@4finance/cwt-test-helper/styles';
import styles from './TestHelperWrapper.module.scss';
import { useLocation, useNavigate } from 'react-router';
import { scenarios } from 'utils/TestHelper/scenarios/scenarios';
import { useClientQuery } from 'hooks/webapi';
import { calculatorSetters } from 'utils/TestHelper/calculatorSetters';
import { useMemo } from 'react';

const TestHelperWrapper = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { data } = useClientQuery();

  const client = useMemo(() => {
    if (!data) return undefined;

    return {
      id: data.id,
      personalId: data.personalId,
      email: data.email?.email ?? '',
    };
  }, [data]);

  const colaUrl = import.meta.env.VITE_COLA_URL;
  const env = import.meta.env.VITE_ENV;
  const webapiUrl = import.meta.env.VITE_LEGACY_LOGIN_API;
  const dashboardUrl = import.meta.env.VITE_DASHBOARD_URL;

  const testHelperEnabled = import.meta.env.VITE_TEST_HELPER_ENABLED;

  const environmentInfo = {
    env,
    webapiUrl,
    colaUrl,
    dashboardUrl,
  };

  if (!testHelperEnabled) return null;

  return (
    <TestHelper
      pathname={pathname}
      scenarios={scenarios}
      client={client}
      environmentInfo={environmentInfo}
      navigate={navigate}
      calculatorSetters={calculatorSetters}
      classNameWrapper={styles.wrapper}
    />
  );
};

export { TestHelperWrapper };
